import { render } from "./ScrollInvitation.vue?vue&type=template&id=dcf9a172&scoped=true"
const script = {}

import "./ScrollInvitation.vue?vue&type=style&index=0&id=dcf9a172&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf9a172"]])

export default __exports__